/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ColumnMetaDateFormat;
(function (ColumnMetaDateFormat) {
    ColumnMetaDateFormat["UNIX"] = "UNIX";
    ColumnMetaDateFormat["ISO"] = "ISO";
    ColumnMetaDateFormat["EXCEL"] = "EXCEL";
    ColumnMetaDateFormat["DD_MM_YYYY"] = "DD_MM_YYYY";
    ColumnMetaDateFormat["MM_DD_YYYY"] = "MM_DD_YYYY";
    ColumnMetaDateFormat["YYYY_MM_DD"] = "YYYY_MM_DD";
    ColumnMetaDateFormat["MM_YYYY"] = "MM_YYYY";
    ColumnMetaDateFormat["YYYY_MM"] = "YYYY_MM";
})(ColumnMetaDateFormat || (ColumnMetaDateFormat = {}));
export function ColumnMetaDateFormatFromJSON(json) {
    return ColumnMetaDateFormatFromJSONTyped(json, false);
}
export function ColumnMetaDateFormatFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ColumnMetaDateFormatToJSON(value) {
    return value;
}
